import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useHydrated } from "../hooks/useHydrated";

export const Testimonials = (props) => {
  const testimonialsRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  const hydrated = useHydrated();

  useEffect(() => {
    const handleScroll = () => {
      if (testimonialsRef.current) {
        const rect = testimonialsRef.current.getBoundingClientRect();
        setIsActive(rect.top <= 500);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Breakpoints belong in slick's own config: deriving slidesToShow from a
  // windowWidth state changes how many clone slides render, so the prerendered
  // markup would not match hydration.
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      { breakpoint: 960, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div id="testimonials" ref={testimonialsRef}>
      <div className="container">
        <div style={{ overflow: "hidden" }} className={`section-title text-center ${isActive ? 'section-title-active' : ''}`}>
          <h2>What Our Clients Say</h2>
          <p>Trusted by businesses across Australia, New Zealand, France, and Asia.</p>
        </div>
        {props.data ? (
          <Slider key={hydrated ? "client" : "prerender"} {...settings}>
            {props.data.map((d, i) => (
              <div key={`${d.name}+${i}`} className="testimonial-item">
                <div className="testimonial-card">
                  <div className="testimonial-stars">
                    {[...Array(5)].map((_, s) => (
                      <i key={s} className="fa fa-star"></i>
                    ))}
                  </div>
                  <p className="testimonial-text">"{d.text}"</p>
                  <div className="testimonial-author">
                    <img src={d.img} alt={d.name} />
                    <div className="testimonial-author-info">
                      <strong>{d.name}</strong>
                      {(d.role || d.company) && (
                        <span>{[d.role, d.company].filter(Boolean).join(', ')}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        ) : "loading"}
      </div>
    </div>
  );
};
